import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { PolicyService } from '../../../service/policy.service';
import { ProcessService } from 'src/app/service/process.service';
import { ProcessModel } from 'src/app/model/process.model';
import { PolicyModel } from '../../../model/policy.model';
import { Router } from '@angular/router';
import swal from 'sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';
import { AttributeModel } from '../../dynamic/model/attribute.model';
import { AuthenticationService } from 'src/app/service/auth.service';


@Component({
  selector: 'app-new',
  templateUrl: './new.component.html',
  styleUrls: ['./new.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NewComponent implements OnInit {

  attribute: AttributeModel;
  politica: PolicyModel;
  politicas: AttributeModel[];
  model: ProcessModel;
  listAttribute: Array<string> = [];
  policies: Array<string> = [];

  constructor(
    private router: Router,
    private policyService: PolicyService,
    private processService: ProcessService,
    private spinner: NgxSpinnerService,
    private authService: AuthenticationService) { }

  ngOnInit() {
    sessionStorage.removeItem('stepCurrent');
    this.policyService.read(sessionStorage.getItem('idPolicy')).subscribe(data => {
      this.loadAttributes(data)
      this.processService.load(this.politicas)
        .subscribe(() => {
          this.validate();
        }, (error)=> this.handleHttpError(error))
    }, (error)=> this.handleHttpError(error));
  }

  validate(): boolean {
    this.politicas.forEach(element => {
      let attributes: AttributeModel[] = element.attributes;
      attributes.forEach(element => {
      });
    });
    return false;
  }

  loadAttributes(data) {
    this.politica = data;
    this.politicas = this.politica.attributes;
    this.politicas.forEach(element => { this.listAttribute.push(element.key); });
    sessionStorage.setItem('politicaAtual', JSON.stringify(this.politicas));
    sessionStorage.setItem('policies', JSON.stringify(this.politicas));
    sessionStorage.setItem('listAttribute', JSON.stringify(this.listAttribute));
    sessionStorage.setItem('stepCurrent', this.politicas[0].key);
  }

  getIconClass(child: AttributeModel): string {

    if (!child.options)
      return null;

    let icon = child.options.find(option => option.key == 'Icon');

    if (icon)
      return icon.value;
  }

  private handleHttpError(error: any) {
    this.spinner.hide();

    if(error.status == 401) {
      this.authService.logout()
      this.router.navigate(['login']);
    } else if(error.status == 403) {
      swal.fire("Atenção", "Este usuário não tem permissão para acessar este conteúdo.")
        .then(() => this.router.navigate([""]).then(() => swal.close()))
    } else if(error.message) {
      swal.fire("Atenção", error.message, "error").then(() => {
        if(error.goBackToHome) {
          this.router.navigate([""]).then(() => swal.close())
        }
      })
    } else {
      swal.fire("Atenção", "Algo errado aconteceu; Por favor, tente novamente.", "error")
    }
  }

}
